import { mainAxios } from "../../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "../mainService";

export const getCampaniasEmailsList = async () => {
  try {
    const response = await mainAxios.get(
      `v1/campanias-emails-eci/list`,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};